module.exports = __webpack_public_path__ + "img/nettkonsesjoner.26cfd700.jpg";